import React from "react";

export default function InfoIcon(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.99984 1.33366C4.31794 1.33366 1.33317 4.31843 1.33317 8.00032C1.33317 11.6822 4.31794 14.667 7.99984 14.667C11.6817 14.667 14.6665 11.6822 14.6665 8.00032C14.6665 4.31843 11.6817 1.33366 7.99984 1.33366Z" stroke={props.fill}stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 10.667V8.00033" stroke={props.fill} stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 5.33301H7.99198" stroke={props.fill} stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
